import { useState, useEffect } from 'react';
import TagToggleOn from '../../../../../../images/tag-toggle-on.svg';
import TagToggleOff from '../../../../../../images/tag-toggle-off.svg';
import TagToggleStarsOn from '../../../../../../images/tag-toggle-stars-on.svg';
import TagToggleStarsOff from '../../../../../../images/tag-toggle-stars-off.svg';

const TagManager = ({
	groups,
	showGroupTitles = false,
	iconType = 'general',
	tagsData,
	onChange,
	filterObject,
	filterType,
}) => {
	const [tags, setTags] = useState(tagsData);

	useEffect(() => {
		if (filterType === 'array') {
			const updatedTags = tagsData.map((tag) => {
				const option = filterObject?.find((option) => option.id === tag.id);

				if (option && option.on) {
					return {
						...tag,
						selected: true,
					};
				}
				return {
					...tag,
					selected: false,
				};
			});

			setTags(updatedTags);
		} else if (filterType === 'object') {
			const updatedTags = tagsData.map((tag) => {
				if (filterObject && filterObject[tag.id]) {
					return {
						...tag,
						selected: true,
					};
				}
				return {
					...tag,
					selected: false,
				};
			});
			setTags(updatedTags);
		}
	}, [tagsData, filterObject, filterType]);

	const toggleTag = (label) => {
		const updatedTags = tags.map((tag) =>
			tag.label === label ? { ...tag, selected: !tag.selected } : tag
		);

		setTags(updatedTags);

		if (onChange) {
			onChange(updatedTags);
		}
	};

	const getToggleIcon = (selected) => {
		switch (iconType) {
			case 'stars':
				return selected ? TagToggleStarsOn : TagToggleStarsOff;
			case 'general':
			default:
				return selected ? TagToggleOn : TagToggleOff;
		}
	};

	const renderTags = (group, idx) => (
		<div style={{ marginBottom: '12px' }} key={idx}>
			{showGroupTitles && (
				<div
					style={{
						fontFamily: 'Satoshi, sans-serif',
						fontSize: '14px',
						fontWeight: '500',
						color: '#4b5080',
						marginLeft: '8px',
					}}>
					{group}
				</div>
			)}
			<div style={{ display: 'flex', flexWrap: 'wrap' }}>
				{tags
					.filter((tag) => tag.group === group)
					.map((tag) => (
						<div
							id={tag.id}
							key={tag.label}
							onClick={() => toggleTag(tag.label)}
							style={{
								fontFamily: 'Satoshi, sans-serif',
								fontSize: '14px',
								fontWeight: '500',
								display: 'inline-flex',
								alignItems: 'center',
								padding: '6px 12px',
								margin: '8px',
								borderRadius: '100px',
								cursor: 'pointer',
								backgroundColor: tag.selected ? '#e8eafe' : '#ffffff',
								color: tag.selected ? '#1c32f3' : '#111827',
								border: tag.selected
									? '1px solid #e8eafe'
									: '1px solid #d1d5db',
								transition: 'background-color 0.2s ease',
							}}
							onMouseEnter={(e) => {
								if (!tag.selected) {
									e.currentTarget.style.backgroundColor = '#fafcfe';
								}
							}}
							onMouseLeave={(e) => {
								if (!tag.selected) {
									e.currentTarget.style.backgroundColor = '#ffffff';
								}
							}}>
							<span
								style={{
									paddingRight: '6px',
									borderRight: '1px solid #d1d5db',
								}}>
								{tag.label}
							</span>
							<div
								style={{
									display: 'flex',
									alignItems: 'center',
									cursor: 'pointer',
									paddingLeft: '6px',
								}}>
								<img
									src={getToggleIcon(tag.selected)}
									alt={tag.selected ? 'ToggleOff' : 'ToggleOn'}
									style={{ width: '14px', height: '14px' }}
								/>
							</div>
						</div>
					))}
			</div>
		</div>
	);

	return <div>{groups.map((group, idx) => renderTags(group, idx))}</div>;
};

export default TagManager;
